var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('networks-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var campaign = ref.campaign;
var proposal = ref.proposal;
var contact = ref.contact;
var proposalStep = ref.proposalStep;
var patchProposalStep = ref.patchProposalStep;
var goNextStep = ref.goNextStep;
var goPreviousStep = ref.goPreviousStep;
var isLoading = ref.isLoading;
var isCompletingProposal = ref.isCompletingProposal;
var errors = ref.errors;
var forceReloadContact = ref.forceReloadContact;
var forceReloadProposal = ref.forceReloadProposal;
var errorMessage = ref.errorMessage;
return [_c('proposal-networks-view',{attrs:{"campaign":campaign,"proposal-step":proposalStep,"proposal":proposal,"contact":contact,"is-loading":isLoading,"is-completing-proposal":isCompletingProposal,"errors":errors,"error-message":errorMessage,"force-reload-contact":forceReloadContact,"force-reload-proposal":forceReloadProposal},on:{"go-next-step":goNextStep,"go-previous-step":goPreviousStep,"patch-step":patchProposalStep}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }